export const ac = (type: string, payload?: any) => ({ type, payload })
